'use client';

import { ELanguage } from '../../Utils/constants.js';
import { VIEWINDEX, DEFAULT_FLOATING_CONFIG } from '../constants.js';

var initialCascaderState = {
    keyword: '',
    isShow: false,
    parentId: -1,
    hoverParentId: -1,
    viewIndex: VIEWINDEX.LEFT,
    isHover: false,
    value: [],
    temporaryValue: [],
    scrollPosition: {
        left: 0,
        right: 0
    },
    searchResult: {
        groupJobFunctions: [],
        jobFunctions: []
    }
};
var initialCascaderProps = {
    langCode: ELanguage.VI,
    isMobile: false,
    floatingConfig: DEFAULT_FLOATING_CONFIG,
    value: [],
    hasError: false,
    options: {
        parent: [],
        children: {},
        jobCount: [],
        isEnableSearchAPI: false
    },
    onConfirm: function (_) { },
    onCancel: function (_) { },
    onBlur: function () { },
    styleOptions: {
        isFlex: false,
        placeholderColor: '',
        isShowSecondaryBtn: false,
        primaryBtnType: 'primary',
        secondaryBtnType: 'primary'
    },
    selectOptions: {
        isSingleSelect: false,
        displayAsPopup: false,
        hiddenFooter: false
    },
    textOptions: {
        placeholder: '',
        primaryBtnText: '',
        secondaryBtnText: ''
    },
    msBaseUrl: 'https://staging-ms.vietnamworks.com',
    lockTarget: '',
    scrollLockMode: 'hard'
};

export { initialCascaderProps, initialCascaderState };
//# sourceMappingURL=index.js.map
